import { createIcon, Svg } from "@gluestack-ui/icon";
import { G, Path } from "react-native-svg";

const CalendarIcon = createIcon({
  Root: Svg,
  viewBox: "0 0 20 20",
  path: (
    <G
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    >
      <Path d="M17.5 8.33268H2.5" />
      <Path d="M17.5 10.416V7.33268C17.5 5.93255 17.5 5.23249 17.2275 4.69771C16.9878 4.2273 16.6054 3.84485 16.135 3.60517C15.6002 3.33268 14.9001 3.33268 13.5 3.33268H6.5C5.09987 3.33268 4.3998 3.33268 3.86502 3.60517C3.39462 3.84485 3.01217 4.2273 2.77248 4.69771C2.5 5.23249 2.5 5.93255 2.5 7.33268V14.3327C2.5 15.7328 2.5 16.4329 2.77248 16.9677C3.01217 17.4381 3.39462 17.8205 3.86502 18.0602C4.3998 18.3327 5.09987 18.3327 6.5 18.3327H10" />
      <Path d="M13.3333 1.66602V4.99935" />
      <Path d="M6.66667 1.66602V4.99935" />
      <Path d="M12.0833 15.8327L13.75 17.4993L17.5 13.7493" />
    </G>
  ),
});

CalendarIcon.displayName = "CalendarIcon";
export { CalendarIcon };
